export default __webpack_public_path__ + "static/media/PdfIcon.efbdfea2.svg";